exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-7ba5bd90] .el-cascader__tags input::-webkit-input-placeholder{color:#fff;opacity:0}", ""]);

// exports
